import { render, staticRenderFns } from "./CompanyLinkList.vue?vue&type=template&id=8a8bdaae&scoped=true&"
import script from "./CompanyLinkList.vue?vue&type=script&lang=js&"
export * from "./CompanyLinkList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a8bdaae",
  null
  
)

export default component.exports